import { FloatBoundKnapSackProps } from "./index119.js";
import { MuscleToVector, getPivot } from "@project-rouge/rg-three";
import { Vector3 } from "three";
function positionSpaces({ spaces, building, availableFreeAreas }) {
	const sorted = spaces.slice().sort((a, b) => a.size[2] !== b.size[2] ? a.size[2] - b.size[2] : a.size[0] - b.size[0]);
	const bags = [];
	const newChildren = [];
	const toPlace = sorted.map((data) => ({
		value: data.size[0],
		data
	}));
	availableFreeAreas.sort((a, b) => b.size[0] - a.size[0]);
	let spaceIndex = 0;
	while (toPlace.length > 0 && spaceIndex < availableFreeAreas.length) {
		const currentArea = availableFreeAreas[spaceIndex];
		const width = currentArea.size[0];
		const bag = FloatBoundKnapSackProps(toPlace, width);
		removeMatches(toPlace, bag.values);
		bags.push([bag, currentArea]);
		spaceIndex++;
	}
	for (const [knapsack, freeArea] of bags) {
		const obj = {
			pos: freeArea.pos,
			anchor: freeArea.anchor,
			size: freeArea.size,
			rot: freeArea.rot
		};
		const bagStart = freeArea.muscle.flip ? getPivot([
			1,
			0,
			0
		], obj) : getPivot([
			0,
			0,
			0
		], obj);
		const bagDirection = freeArea.muscle.flip ? MuscleToVector(freeArea.muscle).normalize().negate() : MuscleToVector(freeArea.muscle).normalize();
		let lastPos = bagStart;
		for (const brick of knapsack.values) {
			const space = brick.data;
			space.data.muscleID = freeArea.muscle.id;
			space.pos = lastPos.clone().add(bagDirection.clone().multiplyScalar(space.size[0] * .5)).toArray();
			space.rot = freeArea.rot;
			space.parent = building;
			space.data.level = freeArea.levelID;
			newChildren.push(space);
			lastPos = new Vector3().fromArray(space.pos).add(bagDirection.clone().multiplyScalar(space.size[0] * .5));
		}
	}
	return {
		technicalSpaces: newChildren,
		leftover: toPlace.map((t) => t.data)
	};
}
function removeMatches(list, matches) {
	for (const item of matches) {
		const i = list.findIndex((a) => a.data === item.data);
		list.splice(i, 1);
	}
}
export { positionSpaces };

//# sourceMappingURL=index120.js.map